import React from "react";
import { Badge } from "reactstrap";
import style from "./Items.module.scss";
import { FormattedDate, FormattedTime } from "react-intl";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";
import { CustodyExtStatus, CustodyIntStatus, getIntStatusName } from "./types";

export const InternalStatus = (status) => (
  <Badge className={`${style.status} ${style[getInternalStatusClass(status)]}`}>
    {getIntStatusName(status).toUpperCase()}
  </Badge>
);

export const Number = (value, dataTypeDecimalName, decimalScale, removeZeros) => (
  <FormattedNumber
    value={value}
    decimalScale={decimalScale}
    dataTypeDecimalName={dataTypeDecimalName}
    removeZeros={removeZeros}
  />
);

export const ExternalStatus = (status) => (
  <Badge className={`${style.status} ${style[getExternalStatusClass(status)]}`}>{status.toUpperCase()}</Badge>
);

export const getExternalStatusClass = (status) => {
  switch (status) {
    case CustodyExtStatus.PrintPending:
      return "color1";
    case CustodyExtStatus.Printed:
      return "color4";
    case CustodyExtStatus.Released:
      return "color3";
    case CustodyExtStatus.Recovered:
      return "color6";
    case CustodyExtStatus.Cancelled:
      return "color5";
    default:
      return "";
  }
};

export const getInternalStatusClass = (status) => {
  switch (status) {
    case CustodyIntStatus.ClientRequest:
      return "color1";
    case CustodyIntStatus.CustodianRequest:
      return "color2";
    case CustodyIntStatus.Executed:
      return "color4";
    case CustodyIntStatus.ClientReturned:
      return "color6";
    case CustodyIntStatus.Returned:
      return "color4";
    case CustodyIntStatus.Lost:
      return "color3";
    case CustodyIntStatus.ReturnRequested:
      return "color4";
    case CustodyIntStatus.CancelRequest:
      return "color2";
    case CustodyIntStatus.Delivered:
      return "color4";
    default:
      return "";
  }
};

export const TDateTime = (date) => {
  return (
    <React.Fragment>
      <FormattedDate value={date} /> <FormattedTime hour12={false} value={date} />
    </React.Fragment>
  );
};

export const StatusEvent = (status) => (
  <Badge className={`${style.status} ${style[getCorpEventStatusClass(status)]}`}>{status}</Badge>
);

export const getCorpEventStatusClass = (status) => {
  switch (status) {
    case "Initiated":
      return "color1";
    case "On Validation":
      return "color6";
    case "Validated":
      return "color6";
    case "Executed":
      return "color4";
    case "Cancelled":
      return "color5";
    default:
      return "";
  }
};
